// ============================================================================
// UNAUTHORIZED PAGE
// Displayed when user lacks permissions for requested resource
// ============================================================================

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function UnauthorizedPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #052831 0%, #063a47 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        padding: '60px 40px',
        borderRadius: '16px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        textAlign: 'center',
        maxWidth: '500px',
        width: '100%'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: '#fff3cd',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 30px',
          fontSize: '40px'
        }}>
          🔒
        </div>

        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#052831',
          marginBottom: '15px'
        }}>
          Access Denied
        </h1>

        <p style={{
          fontSize: '16px',
          color: '#666',
          marginBottom: '10px',
          lineHeight: '1.6'
        }}>
          You don't have permission to access this resource.
        </p>

        {user && (
          <div style={{
            marginTop: '20px',
            padding: '15px',
            background: '#f8f9fa',
            borderRadius: '8px',
            border: '1px solid #e9ecef'
          }}>
            <p style={{
              fontSize: '14px',
              color: '#495057',
              margin: '0 0 8px 0',
              fontWeight: '500'
            }}>
              Current User:
            </p>
            <p style={{
              fontSize: '13px',
              color: '#6c757d',
              margin: '0 0 4px 0'
            }}>
              {user.email}
            </p>
            <p style={{
              fontSize: '12px',
              color: '#868e96',
              margin: '0'
            }}>
              Roles: <span>{user.roles.map(r => r.name).join(', ') || 'none'}</span>
            </p>
          </div>
        )}

        <div style={{
          marginTop: '30px',
          display: 'flex',
          gap: '10px',
          justifyContent: 'center'
        }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '600',
              color: '#052831',
              background: 'white',
              border: '2px solid #052831',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#f8f9fa';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = 'white';
            }}
          >
            Go Back
          </button>

          <button
            onClick={() => navigate('/')}
            style={{
              padding: '12px 24px',
              fontSize: '14px',
              fontWeight: '600',
              color: 'white',
              background: '#052831',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              transition: 'all 0.3s ease'
            }}
            onMouseOver={(e) => {
              e.currentTarget.style.background = '#063a47';
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.background = '#052831';
            }}
          >
            Go to Home
          </button>
        </div>

        <div style={{
          marginTop: '30px',
          paddingTop: '20px',
          borderTop: '1px solid #e9ecef'
        }}>
          <p style={{
            fontSize: '12px',
            color: '#868e96',
            margin: '0'
          }}>
            Contact your system administrator if you believe this is an error.
          </p>
        </div>
      </div>
    </div>
  );
}
